module.exports = __webpack_public_path__ + "static/media/icon_kijkwijzer_12.205f34fd.svg";